import React from 'react';
import { Dialog } from 'primereact/dialog';
import { FiTrash2 } from 'react-icons/fi';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import { Button, buttonVariants } from '@/components/Button';
import {
  IconBadge,
  iconBadgeSizes,
  iconBadgeShapes,
} from '@/components/IconBadge';
import styles from './ConfirmActionDialog.module.scss';

/**
 * Small destructive-action confirmation dialog: icon + title (sharing the
 * PrimeReact Dialog's close-X row, same convention as EmployeeAvatarHeader),
 * a message, and Cancel/Confirm buttons. Replaces PrimeReact's generic
 * confirmDialog() so destructive prompts match the app's own visual design.
 */
export const ConfirmActionDialog = ({
  visible,
  onHide,
  icon = <FiTrash2 size={18} color="var(--error-600)" />,
  iconBg = 'error-100',
  title,
  message,
  cancelLabel = 'Cancel',
  confirmLabel,
  confirmVariant = buttonVariants.red,
  onConfirm,
  loading = false,
}) => (
  <Dialog
    visible={visible}
    onHide={onHide}
    style={{ width: '440px' }}
    header={
      <div className={styles.header}>
        <IconBadge
          icon={icon}
          bg={iconBg}
          size={iconBadgeSizes.lg}
          shape={iconBadgeShapes.circle}
        />
        <Text
          variant={textVariantsEnum.Text_lg}
          fontWeight={fontWeightEnum.Semibold}
        >
          {title}
        </Text>
      </div>
    }
    footer={
      <div>
        <Button
          text={cancelLabel}
          variant={buttonVariants.secondary}
          onClick={onHide}
          disabled={loading}
        />
        <Button
          text={confirmLabel}
          variant={confirmVariant}
          onClick={onConfirm}
          loading={loading}
        />
      </div>
    }
  >
    <Text
      variant={textVariantsEnum.Text_sm}
      fontWeight={fontWeightEnum.Normal}
      color="gray-700"
    >
      {message}
    </Text>
  </Dialog>
);
